let serverTime = 0;
let isInit = false; // 是否已初始化

function serverTiming() {
    serverTime = serverTime + 1000;
}

/**
 * 1，尽量与服务端保持同步的时间戳，利用接口的serverTime，设置进来，然后开始倒计时，精确到秒;
 * 2，当前并没有每次请求都设置serverTime，是由业务实现方来调用set方法设置，才开始倒计时;
 * 3，所以当需要用到本工具，需要自己先调用set，再在需要用的地方get，可以通过isInit来确定是否已被初始化;
 */
const instance = {
    /*
     * 返回是否已初始化，未初始化的serverTime是无效的
     */
    isInit() {
        return isInit;
    },
    /**
     * 返回serverTime
     */
    get() {
        return serverTime || Date.now();
    },
    /**
     * 设置serverTime，尽量每次接口请求都设置进来
     * @param {number} time
     */
    set(time) {
        if (!time) return;
        time = parseInt(time);
        if (Number.isNaN(time)) return;
        serverTime = time;
        if (!isInit && window.CountDown) window.CountDown.add(serverTiming);
        isInit = true;
    },
};

export default instance;
